import { type FieldError, type UseFormRegister } from 'react-hook-form'

type PayDayInputProps = {
  label: string
  description?: string
  register: UseFormRegister<any>
  fieldName: string
  error?: FieldError
  validate?: (value: number) => boolean | string
  onChange?: () => void
  placeholder?: string
}

export const PayDayInput = ({
  label,
  description,
  register,
  fieldName,
  error,
  validate,
  onChange,
  placeholder = 'ex. 1',
}: PayDayInputProps) => (
  <div className='space-y-2'>
    <label className='label-default font-medium text-ds-text-secondary block'>
      {label}
    </label>
    {description && (
      <span className='text-sm label-default text-ds-text-secondary block mb-1'>
        {description}
      </span>
    )}
    <input
      type='number'
      min={1}
      max={31}
      {...register(fieldName, {
        required: true,
        min: {
          value: 1,
          message: 'Pay day must be at least 1'
        },
        max: {
          value: 31,
          message: 'Pay day cannot exceed 31'
        },
        validate,
        onChange,
        setValueAs: (value) => value ? Number(value) : undefined
      })}
      className='input-default w-full'
      placeholder={placeholder}
    />
    {error && (
      <p className='text-red-500 text-xs'>{error.message || 'This field is required'}</p>
    )}
  </div>
)
